import { TIMELINE_PADDING } from "../../core/layoutConstants";
import { SBDActionStyle } from "./types";
import { AddPrefixToObject } from "@shared/common/types/AddPrefixToObject";
import { getTrackGroupDrawPosition } from "@opstel/SBD/core/functions";
import { OccupationTrackGroupDrawDirection } from "@opstel/query/models/trackOccupation";
import { useMemo } from "react";

type TrackGroupDrawProps = {
  readonly order: number;
  readonly maxOrder: number;
  readonly trackGroupDrawDirection: OccupationTrackGroupDrawDirection;
  readonly width: number;
  readonly left: number;
} & Partial<AddPrefixToObject<SBDActionStyle, "$">>;

export function TrackGroupDraw({
  order,
  maxOrder,
  trackGroupDrawDirection,
  left,
  width,
  $backgroundColor,
}: TrackGroupDrawProps): React.JSX.Element | null {
  const { top, bottom } = useMemo(
    () => getTrackGroupDrawPosition(order, maxOrder, trackGroupDrawDirection),
    [maxOrder, order, trackGroupDrawDirection],
  );

  if (top === bottom) {
    return null;
  }

  return (
    <div
      className="absolute z-8 flex opacity-30"
      style={{
        top: `${top}px`,
        left: `${TIMELINE_PADDING + left}px`,
        height: `${bottom - top}px`,
        width: `${width}px`,
        backgroundColor: $backgroundColor,
      }}
    />
  );
}
